import React, { useState } from "react";
import TourShowcase from "./TourShowcase";
import { safeUrl } from "./floating/utils";

/**
 * Right-hand panel of the full-page chatbot's split view.
 *  - preview has an id  -> visual showcase (TourShowcase)
 *  - no id / showcase fetch failed -> the live page in an iframe (?embed=true)
 *
 * Mount with a `key` (type-id-url) so the state below resets for every new card.
 */
export default function PreviewSidebar({ preview, onClose, onOpenPage }) {
  const [showcaseFailed, setShowcaseFailed] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);

  if (preview.id && !showcaseFailed) {
    return (
      <div className="tgh-chatbot-preview-panel">
        <TourShowcase
          preview={preview}
          onClose={onClose}
          onOpenPage={onOpenPage}
          onError={() => setShowcaseFailed(true)}
        />
      </div>
    );
  }

  const url = safeUrl(preview.url);
  // Insert embed=true before any #hash so the param is never swallowed by the fragment
  const [base, hash] = url.split("#");
  const embedUrl = `${base}${base.includes("?") ? "&" : "?"}embed=true${hash ? `#${hash}` : ""}`;

  return (
    <div className="tgh-chatbot-preview-panel">
      <div className="tgh-chatbot-preview-header">
        <div className="tgh-chatbot-preview-title-wrap">
          <span className="tgh-chatbot-preview-pill">Live Sidebar Preview</span>
          <h2 className="tgh-chatbot-preview-heading" title={preview.title}>
            {preview.title || "Tour Experience"}
          </h2>
        </div>
        <div className="tgh-chatbot-preview-btns">
          <a
            href={url}
            onClick={(e) => {
              if (onOpenPage) {
                e.preventDefault();
                onOpenPage(preview.url);
              }
            }}
            className="tgh-chatbot-preview-action-btn"
            title="Open full page"
          >
            Open Page
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 4 }}>
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
          </a>
          <button type="button" onClick={onClose} className="tgh-chatbot-preview-close-btn" title="Close preview">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>

      <div className="tgh-chatbot-preview-body">
        {iframeLoading && (
          <div className="tgh-chatbot-preview-loader">
            <div className="tgh-chatbot-preview-spinner" />
            <p style={{ margin: 0, fontSize: 13, color: "#64748b", fontWeight: 600 }}>Loading live page...</p>
          </div>
        )}
        <iframe
          src={embedUrl}
          onLoad={() => setIframeLoading(false)}
          className="tgh-chatbot-preview-frame"
          title={preview.title || "TGH Webpage Preview"}
        />
      </div>
    </div>
  );
}